import { createFileRoute, Link } from '@tanstack/react-router';

import { PricingScreen } from '../../features/pricing/pricing-screen';
import { PRICING_PERMISSIONS } from '../../features/pricing/types';
import { PricingTabs } from '../../lib/pricing-tabs';
import { RequirePermission } from '../../lib/session/guards';

export const Route = createFileRoute('/pricing/')({
  component: PricingPage,
});

/**
 * `/pricing` — the pricing ruleset editor (MASTER_PLAN M6.11, FR-INS-07, FR-ADMIN-06).
 *
 * `pricing.read` opens it. Publishing needs `pricing.manage`, which the screen reads from
 * the session to decide whether the controls are live — and which the server checks again
 * on `PUT` whatever the buttons look like (rules §17.2, §22.2).
 */
function PricingPage() {
  return (
    <RequirePermission keys={[PRICING_PERMISSIONS.read]}>
      {/* M15: the second tab is the scheduling rules builder at `/pricing/eligibility`. */}
      <PricingTabs />
      <PricingScreen
        reviewQueueLink={
          <Link
            to="/review"
            search={{ kind: '', status: '' }}
            className="text-base text-primary-accessible underline underline-offset-4 hover:text-primary-accessible-hover"
          >
            Review queue
          </Link>
        }
      />
    </RequirePermission>
  );
}
